import crakIds from './crak';

export const GENERIC_ELEMENT_SORT_LIST = [
  'GENERIC_TEXT_AREA_INPUT',
  'GENERIC_MEDIA_INPUT',
  'GENERIC_FILE_INPUT',
  'GENERIC_CHECKBOX_INPUT',
  'SUBMISSION_TYPE_SELECTOR'
];
export const CAMPAIGN_ELEMENT_SORT_LIST = [crakIds.SIGNATURE, crakIds.TERMS_AND_CONDITIONS_INPUT];



// WEBPACK FOOTER //
// ./src/constants/sortLists.js